export type ReviewNoteGuardState = {
  status?: string | null;
  isReadOnlyCancelled?: boolean;
  note?: string | null;
  savedNote?: string | null;
  timeSpentChanged?: boolean;
  selectedCodesChanged?: boolean;
};

function selectedCodesList(value: unknown): unknown[] {
  if (!value || typeof value !== "object") {
    return [];
  }
  const codes = (value as { codes?: unknown }).codes;
  return Array.isArray(codes) ? codes : [];
}

/**
 * True when the clinician changed persistable diagnosis codes since load/save.
 * Empty or still-loading ICD-10 state is not dirty, matching notes that skip
 * the ICD-10 PATCH because there is nothing to write.
 */
export function haveSelectedCodesChanged(current: unknown, snapshot: unknown): boolean {
  const currentCodes = selectedCodesList(current);
  const snapshotCodes = selectedCodesList(snapshot);
  if (currentCodes.length === 0 && snapshotCodes.length === 0) {
    return false;
  }
  try {
    return JSON.stringify(currentCodes) !== JSON.stringify(snapshotCodes);
  } catch {
    return true;
  }
}

/**
 * Whether the Review note modal should prompt before leaving.
 * Matches the Cancel / X / Escape unsaved-changes gate.
 */
export function isReviewNoteDirty({
  status,
  isReadOnlyCancelled = false,
  note = "",
  savedNote = "",
  timeSpentChanged = false,
  selectedCodesChanged = false,
}: ReviewNoteGuardState): boolean {
  return (
    status === "Review" &&
    !isReadOnlyCancelled &&
    ((note || "") !== (savedNote || "") ||
      Boolean(timeSpentChanged) ||
      Boolean(selectedCodesChanged))
  );
}
